/* global window */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage as Translation } from 'react-intl';
import hoistNonReactStatics from 'hoist-non-react-statics';
import EmptyState from 'Components/EmptyState/EmptyState';
import css from './withErrorBoundary.scss';
import { fileNames } from 'Constants/imageUrls';

const withErrorBoundary = (errorTitle, errorDesc, actionButtonText) => Component => {
    class ErrorBoundary extends React.PureComponent {
        static getDerivedStateFromError(error) { // eslint-disable-line
            return { hasError: true };
        }

        static displayName = `withErrorBoundary(${Component.displayName || Component.name})`;

        static propTypes = {
            router: PropTypes.object
        };

        constructor(props) {
            super(props);
            this.state = { hasError: false };
            this.translations = {
                error: errorTitle || <Translation id="error_title" />,
                errorMsg: errorDesc || <Translation id="error_subtitle" />,
                actionButtonText: actionButtonText || <Translation id="action_button_on_error" />
            };
        }

        componentDidCatch(error, errorInfo) {
            this.setState({ hasError: true });
            if (window && window.newrelic && window.newrelic.noticeError) {
                window.newrelic.noticeError(new Error(`[PWA] ErrorBoundary ${error} ${errorInfo}`));
            }
        }

        redirectToHome = () => {
            this.props.router.push('/');
            if (typeof window !== 'undefined') {
                window.location.reload();
            }
        }

        render() {
            if (this.state.hasError) {
                return (
                    <div className={ css.errorContainer }>
                        <EmptyState
                            title={ this.translations.error }
                            asset={ fileNames.ERROR_IMG }
                            buttonText={ this.translations.actionButtonText }
                            onClick={ this.redirectToHome }
                            subTitle={ this.translations.errorMsg }
                        />
                    </div>
                );
            }

            return <Component { ...this.props } />;
        }
    }
    return hoistNonReactStatics(ErrorBoundary, Component);
};

export default withErrorBoundary;
